import { useNavigate } from "react-router-dom";
import shipzo_blue_logo from "../../assets/shipzo_blue.svg";
import { DOMAIN } from "../../consts";
import { USER_ID } from "../../session";
import MenuResponsive from "../responsive-menu";

const Navbar: React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-full !z-[5000]">
        <nav>
          <div className="fixed border-b h-14 w-full bg-white p-2 flex justify-between items-center px-4 !z-[5000]">
            <img
              src={shipzo_blue_logo}
              alt="Shipzo Co."
              className="h-full"
              onClick={() => {
                if (USER_ID) navigate("/");
                else {
                  window.location.replace(DOMAIN);
                }
              }}
            />
            <MenuResponsive />
          </div>
          <div className="h-16" />
        </nav>
      </div>
    </>
  );
};

export default Navbar;
